import React, { FC } from 'react';
import { ErrorPage as ErrorPageUDL } from './component';
import { ErrorPage as ErrorPageLegacy } from './component.legacy';
import { Props } from './types';

export const ErrorPage: FC<Props> = props => {
  if (props.renderAsLegacy || (props.chakra && props.chakra === 'off')) {
    return <ErrorPageLegacy {...props} />;
  }
  return <ErrorPageUDL {...props} />;
};
